export default __webpack_public_path__ + "static/media/chevron-down-1.26807d5e.svg";